import React, { FC } from 'react'
import { Box, Grid, Stack, Text } from '@lojinha/design-system'
import { useLojinhaContext } from '@lojinha/context'
import styled from 'styled-components'
import { MGMStep } from '../mgm-how-it-works-step'
import { MGMStepsData } from '../mgm-how-it-works-step/steps'
import { t } from '../../dictionary'
import { useIndication } from '../../modules/indications/hook'
import { Loading } from '../../modules/indications/loading'

const Background = styled.div`
  width: 100%;
  background-color: ${({ theme }) => theme.colors.grapeLight};
`

export const MGMHowItWorks: FC = () => {
  const { referralRewardAmount, referralDiscount, loading } = useIndication()
  const { isContextLoaded } = useLojinhaContext()

  if (loading || !isContextLoaded) return <Loading />

  return (
    <Background>
      <Box
        display={'flex'}
        flexDirection={'column'}
        justifyContent={'center'}
        height={'100%'}
        py={['x40', 'x64']}
      >
        <Box px={'x16'}>
          <Stack margin={'x24'}>
            <Grid gridTemplateColumns="repeat(10, 1fr)">
              <Grid gridColumn={['1 / 13', '2 / 4']}>
                <Text isBrand color={'grapeLightSupport'}>
                  {t.mgm.howItWorks.toUpperCase()}
                </Text>
              </Grid>
            </Grid>
            <Grid gridTemplateColumns={['repeat(12, 1fr)', 'repeat(10, 1fr)']}>
              <Grid gridColumn={['1 / 13', '2 / 4']}>
                <MGMStep
                  title={MGMStepsData()[0].title}
                  description={
                    MGMStepsData(referralRewardAmount, referralDiscount)[0]
                      .description
                  }
                  image={MGMStepsData()[0].image}
                  ariaLabel={
                    MGMStepsData(referralRewardAmount, referralDiscount)[0]
                      .ariaLabel
                  }
                />
              </Grid>
              <Grid gridColumn={['1 / 13', '5 / 7']}>
                <MGMStep
                  title={MGMStepsData()[1].title}
                  description={
                    MGMStepsData(referralRewardAmount)[1].description
                  }
                  image={MGMStepsData()[1].image}
                  ariaLabel={MGMStepsData(referralRewardAmount)[1].ariaLabel}
                />
              </Grid>
              <Grid gridColumn={['1 / 13', '8 / 10']}>
                <MGMStep
                  title={MGMStepsData()[2].title}
                  description={MGMStepsData()[2].description}
                  image={MGMStepsData()[2].image}
                />
              </Grid>
            </Grid>
          </Stack>
        </Box>
      </Box>
    </Background>
  )
}
